module.exports = __webpack_public_path__ + "/bundle/asset/U1_03-44e4fdb4c16c158d6851a7ca87c4a4f5.gif";